import * as React from "react";
import { FieldRenderProps } from "react-final-form";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material";
import { FormApi } from "final-form";
import { useEffect } from "react";

interface ISelectOption {
  value: string | number;
  label: string;
  condition?: boolean;
}

interface ISelectFieldControl {
  showDirty?: boolean;
  formAPI?: FormApi;
  label?: string;
  emptyOption?: boolean;
  options?: Array<ISelectOption>;
  renderIcon?: (value: any) => React.ReactNode;
  handleChange?: (...args: any[]) => any;
  disabled?: boolean;
  // tslint:disable-next-line: no-any
  onchange?: (e: any) => any;
  partialValue?: boolean;
}

const SelectFieldControl = (props: FieldRenderProps<any> & ISelectFieldControl) => {
  const {
    classes,
    input: { name, onChange, value, ...restInput },
    meta,
    label,
    emptyOption,
    options,
    renderIcon,
    disabled,
    onchange,
    showDirty,
    formAPI,
    handleChange,
    partialValue,
    ...rest
  } = props;

  useEffect(() => {
    if (formAPI) {
      const state = formAPI.getFieldState(name);
      if (state?.modified && meta.initial === value) {
        formAPI.resetFieldState(name);
      }
    }

    if (handleChange) {
      handleChange(value, meta.initial === value);
    }
  }, [value]);

  return (
    <Component
      {...rest}
      label={label}
      inputProps={restInput as any}
      className={`${meta.dirty && showDirty ? "touched" : ""}`}
      value={value}
      name={name}
      // tslint:disable-next-line: no-any
      onChange={(e: any) => {
        onChange(e);
        if (onchange) {
          onchange(e);
        }
      }}
      // style={{ borderColor: "rgba(255, 255, 255, 0.23)" }}
      select={true}
      variant="outlined"
      fullWidth={true}
      error={Boolean((meta.error || meta.submitError) && meta.touched ? meta.error || meta.submitError : undefined)}
      helperText={(meta.error || meta.submitError) && meta.touched ? meta.error || meta.submitError : undefined}
      disabled={disabled}
    >
      {emptyOption && (
        <MenuItem
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "12px 16px",
          }}
          value={label}
        >
          {label}
        </MenuItem>
      )}
      {options &&
        options.map((o, index) => (
          <MenuItem
            key={index}
            value={o.value}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "12px 16px",
              backgroundColor: o.condition ? "rgb(70, 130, 195, 0.5)" : "unset",
            }}
          >
            {renderIcon && <IconWrap className={classes?.icon}>{renderIcon(o)}</IconWrap>}
            <span>{partialValue && o.value === value ? o.value : o.label}</span>
          </MenuItem>
        ))}
    </Component>
  );
};

const IconWrap = styled("div")`
  display: flex;
  align-items: center;
`;

const Component = styled(TextField)`
  div[role="button"] {
    padding: 12px 14px;
  }
  label {
    color: #949494;
  }
  label.labelFocused,
  label.labelFilled {
    color: black;
  }
  & > div > div {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  &.touched {
    & fieldset {
      border-color: rgb(255 182 0 / 70%);
    }
  }
`;
export default SelectFieldControl;
